import isUndefinedOrNull from '@zenbusiness/application-commons-utils/isUndefinedOrNull';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import PaymentStatusLabel from '#client/components/PaymentStatusLabel';
import FieldDetail from '#client/components/TransactionDetailModal/components/FieldDetail';
import MoneyDetail from '#client/components/TransactionDetailModal/components/MoneyDetail';
import { DATE_FORMAT } from '#client/constants/date';

export default function PaymentDetail({
  amount,
  createdAt,
  estimatedCompletionDate,
  type,
  id,
  status,
  reason,
  sameDay,
  description
}) {
  const createdAtText = dayjs(createdAt).format(DATE_FORMAT.MOVE_MONEY);
  const estimatedCompletionDateText = estimatedCompletionDate
    ? dayjs(estimatedCompletionDate).format(DATE_FORMAT.MOVE_MONEY)
    : '';

  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', md: '56px' }}
      pt={{ xs: '24px', md: '32px' }}
      px={{ xs: '24px', md: '32px' }}
      rowSpacing={{ xs: '16px', md: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            Transaction details
          </Text>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="Amount"
            value={amount}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="Date Initiated"
        value={createdAtText}
      />
      <FieldDetail
        label="Type"
        value={type}
      />
      <FieldDetail
        label="Estimated Completion Date"
        value={estimatedCompletionDateText}
      />
      <FieldDetail
        label="ID"
        value={id}
      />
      <Grid
        item
        md={4}
        xs={12}
      >
        <Stack
          direction="column"
          gap="8px"
        >
          <Text
            color="tertiary"
            size="xs"
            uppercase
          >
            Status
          </Text>
          <PaymentStatusLabel status={status} />
        </Stack>
      </Grid>
      <FieldDetail
        label="Reason"
        value={reason}
      />
      {!isUndefinedOrNull(sameDay) && (
        <FieldDetail
          label="Speed"
          value={sameDay ? 'Same Day' : 'Next Day'}
        />
      )}
      <FieldDetail
        label="Transaction Description"
        value={description}
      />
    </Grid>
  );
}

PaymentDetail.propTypes = {
  amount: PropTypes.string,
  createdAt: PropTypes.string,
  estimatedCompletionDate: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.string,
  reason: PropTypes.string,
  sameDay: PropTypes.bool,
  description: PropTypes.string
};
